// import React, { useRef, useState } from "react";

// const InfoWrapper = ({
//   children,
//   wrapperClassName,
//   className,
//   disableDrag = false,
//   dragThreshold = 6,
// }) => {
//   const wrapperRef = useRef(null);
//   const pointerIdRef = useRef(null);
//   const startXRef = useRef(0);
//   const startScrollLeftRef = useRef(0);
//   const latestClientXRef = useRef(0);
//   const rafIdRef = useRef(0);
//   const didDragRef = useRef(false);
//   const suppressClickUntilRef = useRef(0);
//   const hasPointerCaptureRef = useRef(false);
//   const [isDragging, setIsDragging] = useState(false);

//   const isMousePointer = (e) => !e.pointerType || e.pointerType === "mouse";

//   const defaultWrapperClassName = `flex gap-4 overflow-auto pb-2${
//     disableDrag ? "" : " cursor-grab select-none"
//   }`;
//   const combinedWrapperClassName = `${defaultWrapperClassName} ${wrapperClassName || ""}`;

//   const defaultClassName = "min-w-[200px] flex-1";
//   const combinedClassName = `${defaultClassName} ${className || ""}`;

//   const onPointerDown = (e) => {
//     if (disableDrag) return;
//     if (!isMousePointer(e)) return;
//     if (e.button != null && e.button !== 0) return;
//     if (
//       e.target instanceof Element &&
//       e.target.closest("button,a,input,textarea,select,[role='button']")
//     )
//       return;
//     const el = wrapperRef.current;
//     if (!el) return;

//     pointerIdRef.current = e.pointerId;
//     startXRef.current = e.clientX;
//     latestClientXRef.current = e.clientX;
//     startScrollLeftRef.current = el.scrollLeft;
//     didDragRef.current = false;
//     hasPointerCaptureRef.current = false;
//     setIsDragging(false);
//   };

//   const onPointerMove = (e) => {
//     if (disableDrag) return;
//     if (!isMousePointer(e)) return;
//     const el = wrapperRef.current;
//     if (!el) return;
//     if (pointerIdRef.current == null) return;
//     if (pointerIdRef.current != null && e.pointerId !== pointerIdRef.current)
//       return;

//     latestClientXRef.current = e.clientX;
//     const dx = latestClientXRef.current - startXRef.current;
//     if (!didDragRef.current && Math.abs(dx) > dragThreshold) {
//       didDragRef.current = true;
//       setIsDragging(true);

//       if (!hasPointerCaptureRef.current && typeof el.setPointerCapture === "function") {
//         try {
//           el.setPointerCapture(e.pointerId);
//           hasPointerCaptureRef.current = true;
//         } catch (_) {}
//       }
//     }

//     if (!didDragRef.current) return;
//     if (rafIdRef.current) return;
//     rafIdRef.current = window.requestAnimationFrame(() => {
//       rafIdRef.current = 0;
//       const target = wrapperRef.current;
//       if (!target) return;
//       const dxRaf = latestClientXRef.current - startXRef.current;
//       target.scrollLeft = startScrollLeftRef.current - dxRaf;
//     });

//     e.preventDefault();
//   };

//   const endDrag = (e, keepSuppressClick = false) => {
//     if (disableDrag) return;
//     if (rafIdRef.current) {
//       window.cancelAnimationFrame(rafIdRef.current);
//       rafIdRef.current = 0;
//     }
//     if (
//       hasPointerCaptureRef.current &&
//       e &&
//       wrapperRef.current &&
//       typeof wrapperRef.current.releasePointerCapture === "function"
//     ) {
//       try {
//         wrapperRef.current.releasePointerCapture(e.pointerId);
//       } catch (err) {}
//     }
//     hasPointerCaptureRef.current = false;
//     pointerIdRef.current = null;
//     setIsDragging(false);
//     if (keepSuppressClick && didDragRef.current) {
//       suppressClickUntilRef.current = Date.now() + 400;
//     } else {
//       suppressClickUntilRef.current = 0;
//     }
//     didDragRef.current = false;
//   };

//   const onPointerUp = (e) => endDrag(e, true);
//   const onPointerCancel = (e) => endDrag(e, false);
//   const onPointerLeave = (e) => endDrag(e, false);

//   const onClickCapture = (e) => {
//     if (disableDrag) return;
//     if (Date.now() > suppressClickUntilRef.current) return;
//     e.preventDefault();
//     e.stopPropagation();
//     suppressClickUntilRef.current = 0;
//   };

//   return (
//     <div
//       ref={wrapperRef}
//       className={`${combinedWrapperClassName} ${
//         isDragging && !disableDrag ? "cursor-grabbing" : ""
//       }`}
//       onPointerDown={!disableDrag ? onPointerDown : undefined}
//       onPointerMove={!disableDrag ? onPointerMove : undefined}
//       onPointerUp={!disableDrag ? onPointerUp : undefined}
//       onPointerCancel={!disableDrag ? onPointerCancel : undefined}
//       onPointerLeave={!disableDrag ? onPointerLeave : undefined}
//       onClickCapture={!disableDrag ? onClickCapture : undefined}
//       style={{ WebkitOverflowScrolling: "touch" }}
//     >
//       {React.Children.toArray(children).map((child, idx) => (
//         <div key={child?.key ?? idx} className={combinedClassName}>
//           {child}
//         </div>
//       ))}
//     </div>
//   );
// };

// export default InfoWrapper;

import React from "react";

const InfoWrapper = ({ children, wrapperClassName, className }) => {
  const defaultWrapperClassName = "flex gap-4 overflow-auto pb-2 pt-1";
  const combinedWrapperClassName = `${defaultWrapperClassName} ${
    wrapperClassName || ""
  }`;

  const defaultClassName = "min-w-[200px] flex-1";
  const combinedClassName = `${defaultClassName} ${className || ""}`;

  return (
    <div className={combinedWrapperClassName}>
      {React.Children.toArray(children).map((child) => (
        <div key={child.key} className={combinedClassName}>
          {child}
        </div>
      ))}
    </div>
  );
};

export default InfoWrapper;
